import request from "@/utils/request";

export default {
    searchCardByCardId: function (params) {
        return request({
            url: `/user/agent/card/searchCardByCardId`,
            params: params
        })
    }
}
